import {
  Component,
  ErrorHandler,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent
  implements OnInit, OnChanges, ErrorHandler, AfterViewInit
{
  @Input() tabs: Tab[] = [];
  @Input() currentTab?: number;
  @Input() dashboardTab: boolean = false;
  @Output() onChangeTab = new EventEmitter<number>();

  @ViewChild('tabsList', { static: false }) tabsList!: ElementRef;

  activedTab: number = 0;
  posX = '0px';
  width = '0px';

  canScrollLeft: boolean = false;
  canScrollRight: boolean = false;
  showArrows: boolean = false;

  constructor() {}

  handleError(error: any): void {
    console.table(error);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentTab) {
      if (this.currentTab !== this.activedTab) {
        this.activedTab = this.currentTab;
        this.setIndicator();
      }
    }
  }

  ngOnInit(): void {
    if (this.currentTab) {
      this.activedTab = this.currentTab;
    }
  }

  ngAfterViewInit(): void {
    this.checkScrollState();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkScrollState();
  }

  checkScrollState(): void {
    setTimeout(() => {
      if (this.tabsList) {
        const element = this.tabsList.nativeElement;
        this.canScrollLeft = element.scrollLeft > 0;
        this.canScrollRight =
          element.scrollLeft < element.scrollWidth - element.clientWidth;
        this.showArrows = element.scrollWidth > element.clientWidth;
      }
    }, 100);
  }

  scrollLeft(): void {
    if (this.tabsList && this.canScrollLeft) {
      const element = this.tabsList.nativeElement;
      element.scrollBy({ left: -400, behavior: 'smooth' });
      setTimeout(() => this.checkScrollState(), 300);
    }
  }

  scrollRight(): void {
    if (this.tabsList && this.canScrollRight) {
      const element = this.tabsList.nativeElement;
      element.scrollBy({ left: 400, behavior: 'smooth' });
      setTimeout(() => this.checkScrollState(), 300);
    }
  }

  onScroll(): void {
    this.checkScrollState();
  }

  setIndicator() {
    setTimeout(() => {
      const elements: any = document.querySelectorAll('.app-tabs-item');
      if (elements[this.activedTab]) {
        this.width = `${elements[this.activedTab].offsetWidth}px`;
        this.posX = `${elements[this.activedTab].offsetLeft}px`;
      }
      this.checkScrollState();
    }, 1000);
  }

  ngAfterContentChecked() {
    this.setIndicator();
  }

  activeTab(index: number, event: any): void {
    if (this.tabs[index].disabled) {
      return;
    }
    const element = event.srcElement;

    this.width = `${element.offsetWidth}px`;
    this.posX = `${element.offsetLeft}px`;

    this.activedTab = index;
    this.onChangeTab.emit(index);
  }
}
